let csrfToken: string | null = null;

export async function initCsrf(): Promise<void> {
  const res = await fetch('/auth/csrf-token', { credentials: 'include' });
  if (!res.ok) throw new Error('CSRF-Token konnte nicht geladen werden');
  const data = (await res.json()) as { token: string };
  csrfToken = data.token;
}

export function getCsrfToken(): string | null {
  return csrfToken;
}

export function clearCsrfToken(): void {
  csrfToken = null;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiFetch<T>(
  url: string,
  init: Omit<RequestInit, 'body'> & { body?: unknown } = {},
): Promise<T> {
  const method = (init.method ?? 'GET').toUpperCase();
  const headers = new Headers(init.headers as HeadersInit);

  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    if (csrfToken) headers.set('X-CSRF-Token', csrfToken);
  }

  let fetchBody: BodyInit | null | undefined;
  if (init.body !== undefined && init.body !== null) {
    if (typeof init.body === 'string' || init.body instanceof FormData || init.body instanceof Blob) {
      fetchBody = init.body as BodyInit;
    } else {
      fetchBody = JSON.stringify(init.body);
      if (!headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
    }
  }

  const res = await fetch(url, { ...init, body: fetchBody, headers, credentials: 'include' });

  if (res.status === 401) {
    clearCsrfToken();
    window.location.href = '/login';
    throw new ApiError(401, 'Nicht authentifiziert');
  }

  if (!res.ok) {
    let message = `HTTP ${res.status}`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body.error) message = body.error;
    } catch {
      // ignore parse error
    }
    throw new ApiError(res.status, message);
  }

  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}
